/*=========================================================================================
  File Name: moduleShopActions.js
  Description: Shop Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';

export default {
  /* ========================= Shop========================= */
  ArchiveOrActiceShop({}, Id) {
    return new Promise((resolve, reject) => {
      axios

        .get(`shops/${Id}/soft-delete`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async AddShop({}, Credentials) {
    delete Credentials.address.country_name;

    return new Promise((resolve, reject) => {
      axios
        .post('shops', Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  // async EditShop({}, Credentials) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .patch(`shops/${Credentials.id}`, Credentials)
  //       .then((resp) => {
  //
  //         resolve(resp);
  //       })
  //       .catch((err) => {
  //
  //         reject(err.response);
  //       });
  //   });
  // },
  GetShopSingleId({}, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`shops/${id}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  EditShop({}, Credentials) {
    let id = Credentials.id;
    delete Credentials.id;
    delete Credentials.created_at;
    delete Credentials.deleted_at;
    delete Credentials.is_active;
    delete Credentials.updated_at;
    delete Credentials.account;
    delete Credentials.address.country_name;
    delete Credentials.address.state;
    delete Credentials.contact.full_name;
    return new Promise((resolve, reject) => {
      axios
        .patch(`shops/${id}`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetShop({}, payload) {
    let url = 'shops/search?';
    if (payload != null && payload != undefined) {
      if (payload.query != '' && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (payload.status != undefined && payload.status != null) {
        url += `status=${payload.status}&`;
      }
      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  getBankDetails({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`banks/search?query=${payload}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetAllShopsDetails({}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`shops`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  AssignShopToWarehouse({}, credentials) {
    const WarehouseId = credentials.WarehouseId;
    delete credentials.WarehouseId;
    return new Promise((resolve, reject) => {
      axios
        .post(`ware-houses/${WarehouseId}/shops`, credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetStocksinShop({ commit }, payload) {
    let url = `shops/${payload}/stocks`;

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          commit('SET_BREADCRUMB', resp.data.data[0].id, {
            root: true,
          });
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  GetSalesinShop({ commit }, payload) {
    let url = `shops/${payload}/sales`;

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  RemoveShopFromWarehouse({}, credentials) {
    const WarehouseId = credentials.WarehouseId;
    delete credentials.WarehouseId;
    return new Promise((resolve, reject) => {
      axios
        .delete(`ware-houses/${WarehouseId}/shops`, { data: credentials })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
